var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27417 8.40234L7.27417 10.4023L11.2742 6.40234M5.47417 14.4023H11.0742C12.1943 14.4023 12.7543 14.4023 13.1822 14.1844C13.5585 13.9926 13.8644 13.6866 14.0562 13.3103C14.2742 12.8825 14.2742 12.3224 14.2742 11.2023V5.60234C14.2742 4.48224 14.2742 3.92219 14.0562 3.49436C13.8644 3.11804 13.5585 2.81208 13.1822 2.62033C12.7543 2.40234 12.1943 2.40234 11.0742 2.40234H5.47417C4.35407 2.40234 3.79401 2.40234 3.36619 2.62033C2.98986 2.81208 2.6839 3.11804 2.49216 3.49436C2.27417 3.92219 2.27417 4.48224 2.27417 5.60234V11.2023C2.27417 12.3224 2.27417 12.8825 2.49216 13.3103C2.6839 13.6866 2.98986 13.9926 3.36619 14.1844C3.79401 14.4023 4.35406 14.4023 5.47417 14.4023Z",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.2bea05850e91ee4b408c4478d39f24d7.svg";
export { ForwardRef as ReactComponent };